import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { SharedUserAuthorizationService } from "@mrdm-self-service-frontend/shared/data-access-authorization";
import { AuthorizationPermission } from "@mrdm-self-service-frontend/shared/types";
import { of } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { switchMap, tap } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})
export class AdministrationAuthorizationGuard  {
    private _router = inject(Router);
    private _sharedAuthorization = inject(SharedUserAuthorizationService);


    canActivate(
        next: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this._checkAccess(next.routeConfig);
    }

    canLoad(
        route: Route,
        _segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this._checkAccess(route);
    }

    private _checkAccess(route: Route | null): Observable<boolean> {
        // user have access for at leas one org
        return this._sharedAuthorization.userPermissions$.pipe(
            switchMap((permissions: AuthorizationPermission[]) => {
                if (permissions.length > 0) {
                    const expected: string[] = route?.data?.expectedPermissions;
                    return of(
                        permissions.some(permission =>
                            this.hasPermission(permission.permissions, expected)
                        )
                    );
                } else {
                    return of(false);
                }
            }),
            tap(hasAccess => {
                if (!hasAccess) {
                    this._router.navigate(["access-denied"]);
                }
            })
        );
    }

    public hasPermission(permissions: string[], expectedPermissions: string[]): boolean {
        if (expectedPermissions == null) return true;

        for (const permission of expectedPermissions) {
            if (permissions.indexOf(permission) !== -1) return true;
        }

        return false;
    }
}
